import { useMatch, useSearchParams } from 'react-router';

import routes from '@/assets/constants/routes-no.ts';
import { useIsAfterDate } from '@/hooks/useIsAfterDate.ts';

import {
  SUMMER_JULY_2024_COMPETITION_END_DATE,
  SUMMER_JUNE_2024_COMPETITION_END_DATE,
} from '../../../config.ts';

export const useHasEnded = (month: 'june' | 'july' | 'auto' = 'auto') => {
  const [params] = useSearchParams();
  const isJune = Boolean(useMatch(routes.SUMMER_JUNE_2024_COMPETITION));
  const date = (() => {
    if (month === 'june') {
      return SUMMER_JUNE_2024_COMPETITION_END_DATE;
    }
    if (month === 'july') {
      return SUMMER_JULY_2024_COMPETITION_END_DATE;
    }
    return isJune ? SUMMER_JUNE_2024_COMPETITION_END_DATE : SUMMER_JULY_2024_COMPETITION_END_DATE;
  })();

  return useIsAfterDate(date) || params.has('ended');
};
